import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { mockQuestions, mockAnswers } from '../data/mockCommunity';
import SafeIcon from '../components/common/SafeIcon';
import AnswerCard from '../components/community/AnswerCard';

export default function QuestionDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [newAnswer, setNewAnswer] = useState('');
  
  const question = mockQuestions.find(q => q.id === id);
  const answersRaw = mockAnswers[id] || [];

  // Lógica de ordenamiento: Curada primero, luego por votos descendente
  const answers = [...answersRaw].sort((a, b) => {
    if (a.isCurated) return -1;
    if (b.isCurated) return 1;
    return b.upvotes - a.upvotes;
  });

  if (!question) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    setNewAnswer('');
    // Aquí iría la lógica para enviar la respuesta.
    alert('¡Tu respuesta ha sido publicada!');
  };

  return (
    <div className="min-h-screen bg-[var(--bg-base)] pb-24 md:pb-12 transition-colors duration-300">
      
      {/* Sticky Header Nav */}
      <div className="sticky top-0 z-30 bg-[var(--bg-base)]/90 backdrop-blur-md p-4 px-6 md:px-12 flex items-center gap-4 border-b border-[var(--border-subtle)]">
        <button 
          onClick={() => navigate('/app/comunidad')}
          className="w-10 h-10 rounded-full bg-[var(--bg-surface)] hover:bg-[var(--border-subtle)] flex items-center justify-center text-[var(--text-main)] transition-colors border border-[var(--border-subtle)]"
        >
          <SafeIcon name="ArrowLeft" className="w-5 h-5" />
        </button>
        <span className="font-bold text-[10px] uppercase tracking-[0.2em] text-[var(--text-secondary)]">
          Volver a Comunidad
        </span>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-10">
        
        {/* Question Header & Body */}
        <div className="mb-12">
          <div className="flex gap-2 mb-6">
            <span className="px-3 py-1 bg-[var(--bg-surface)] border border-[var(--border-subtle)] text-[var(--text-main)] rounded-full text-[10px] font-black uppercase tracking-widest shadow-sm">
              {question.category}
            </span>
          </div>

          <h1 className="text-3xl md:text-5xl font-black text-[var(--text-main)] leading-[1.1] tracking-tighter uppercase italic mb-6">
            {question.title}
          </h1>

          <div className="flex items-center gap-4 mb-8">
            <div className="w-10 h-10 rounded-full bg-brand-navy flex items-center justify-center text-xs font-black text-white">
              {question.authorAvatar}
            </div>
            <div>
              <p className="text-xs font-black text-[var(--text-main)] uppercase tracking-tight">Preguntado por {question.author}</p>
              <p className="text-[9px] font-bold text-[var(--text-secondary)] uppercase tracking-widest mt-0.5">{question.date}</p>
            </div>
          </div>

          <div className="bg-[var(--bg-surface)] border border-[var(--border-subtle)] p-6 md:p-8 rounded-3xl shadow-sm relative">
            <SafeIcon name="Quote" className="absolute top-6 right-6 w-12 h-12 text-[var(--border-subtle)] opacity-50" />
            <p className="text-[var(--text-main)]/80 text-lg leading-relaxed font-medium relative z-10">
              {question.description}
            </p>
          </div>
        </div>

        {/* Answers Section */}
        <div className="mb-12">
          <h2 className="text-xl font-black text-[var(--text-main)] uppercase tracking-tight italic mb-8 flex items-center gap-3">
            <span className="w-8 h-8 rounded-full bg-[var(--text-main)] text-[var(--bg-base)] flex items-center justify-center text-sm">
              {answers.length}
            </span>
            Respuestas
          </h2>

          {answers.length > 0 ? (
            <div className="space-y-6">
              {answers.map(answer => (
                <AnswerCard key={answer.id} answer={answer} />
              ))}
            </div>
          ) : (
            <div className="text-center py-12 bg-[var(--bg-surface)] border border-[var(--border-subtle)] rounded-3xl">
              <SafeIcon name="MessageCircle" className="w-12 h-12 text-[var(--border-subtle)] mx-auto mb-4" />
              <p className="text-[var(--text-secondary)] text-sm font-medium">Aún no hay respuestas. ¡Sé el primero en ayudar!</p>
            </div>
          )}
        </div>

        {/* Add Answer Form */}
        <div className="bg-[var(--bg-surface)] border border-[var(--border-subtle)] rounded-3xl p-6 md:p-8 shadow-sm">
          <h3 className="text-sm font-black text-[var(--text-main)] uppercase tracking-[0.2em] mb-4">
            Tu Respuesta
          </h3>
          <form onSubmit={handleSubmit}>
            <textarea
              value={newAnswer}
              onChange={(e) => setNewAnswer(e.target.value)}
              placeholder="Escribe tu conocimiento aquí. Recuerda ser claro, respetuoso y aportar valor práctico..."
              className="w-full bg-[var(--bg-base)] border border-[var(--border-subtle)] rounded-2xl py-4 px-6 text-sm text-[var(--text-main)] placeholder-[var(--text-secondary)]/50 focus:outline-none focus:border-brand-green focus:ring-1 focus:ring-brand-green transition-all resize-none min-h-[150px] mb-4"
              required
            />
            <div className="flex justify-end">
              <button 
                type="submit"
                disabled={!newAnswer.trim()}
                className="gfi-gradient-bg text-brand-navy px-8 py-3.5 rounded-xl font-black text-xs uppercase tracking-widest transition-all transform hover:scale-105 shadow-lg disabled:opacity-50 disabled:grayscale disabled:hover:scale-100 disabled:cursor-not-allowed"
              >
                Publicar Respuesta
              </button>
            </div>
          </form>
        </div>

      </div>
    </div>
  );
}